/** A level's values in words, as the Values sheet says them: by the same names, in the same units. */
import { RULES } from '@bramvasterd/terrella-rules';

import type { UpgradeStat } from '@game/upgrade/upgrades';
import { duration, t, type MessageKey } from '@i18n/index';

/** Each value by the name the sheet gives it. */
export const STAT_LABEL: Readonly<Record<UpgradeStat, MessageKey>> = {
  storage: 'info.holds',
  ingest: 'info.intake',
  range: 'info.reach',
};

/** "24", "3", "its own tile", "reach 1 step". */
export const valueText = (stat: UpgradeStat, n: number): string =>
  stat === 'range' ? t('info.steps', { n }) : String(n);

/** What a value is counted in, after it: what it takes in is per period. */
export const unitText = (stat: UpgradeStat): string | null =>
  stat === 'ingest' ? t('info.per', { period: duration(RULES.extractMs) }) : null;
